import styles from "../../object-passport.module.css";

import { Flex } from "antd";

import CopyLink from "../CopyLink";

import { formateISODateToStr } from "@/utils";

const Header = ({ date, printBtn, config }) => {
  return (
    <div className={styles.header}>
      <div className={styles.container}>
        <Flex justify="space-between" align="center">
          <div className={styles.logoWrap}>
            {config?.logo_path && (
              <img
                src={config.logo_path}
                width={32}
                height={32}
                alt=""
                className={styles.logo}
              />
            )}
            <span className={styles.logoName}>
              {!config?.is_red_logo ? (
                config?.system_name
              ) : (
                <div className={styles.namePlaceholder}>
                  {config?.system_name}
                </div>
              )}
            </span>
          </div>

          <div className={styles.headerTitle}>
            Паспорт объекта
            <span className={styles.date}>{formateISODateToStr(date)}</span>
          </div>

          <Flex gap={16} align="center">
            <CopyLink />

            {printBtn}
          </Flex>
        </Flex>
      </div>
    </div>
  );
};
export default Header;
